<tt-page *ngIf="!!page">
    <div class="row-fluid">
        <form class="form-horizontal im-no-pad" novalidate method="get" role="form">
            <div class="col-xs-12 well well-sm">
                <tt-card class="col-xs-12 col-md-6 p-5">
                    <tt-input class="col-xs-12 sp-0" ttLabel="case_keyno" [ttModel]="page.case_keyno" ttReadonly></tt-input>
                    <tt-input class="col-xs-12 sp-0" ttLabel="colli_content" [(ttModel)]="page.colli_content"></tt-input>
                    <im-input-directive label="volume_m3" [field]="page.volume_m3" (fieldChange)="page.volume_m3 = $event" placeholder="" type="input" typevar="bn6s"></im-input-directive>
                    <im-input-directive label="weight_kg" [field]="page.weight_kg" (fieldChange)="page.weight_kg = $event" placeholder="" type="input" typevar="bn3s"></im-input-directive>
                    <tt-input class="col-xs-12 sp-0" ttLabel="reg_datetime" [ttModel]="page.reg_datetime" ttReadonly></tt-input>
                    <tt-input class="col-xs-12 sp-0" ttLabel="colli_dispatch_ean" [ttModel]="page.colli_dispatch_ean" ttReadonly></tt-input>
                </tt-card>

                <tt-card class="col-xs-12 col-md-6 p-5">
                    <tt-select
                        class="col-xs-12 sp-0"
                        ttLabel="printergroup"
                        [ttModel]="page.printergroup_id"
                        (ttModelChange)="onPrinterGroupChanged($event)"
                        [ttData]="selectListPrinterGroups"
                        ttDataId="item_id"
                        ttDataName="item_name"
                    ></tt-select>
                    <ng-container *ngIf="showPrinterGroupOptions">
                        <tt-select
                            *ngIf="showPrinterLocation"
                            class="col-xs-12 sp-0"
                            ttLabel="printerlocation"
                            [ttModel]="page.printerlocation_id"
                            (ttModelChange)="onPrinterLocationChanged($event)"
                            [ttData]="selectListPrinterLocations"
                            ttDataId="item_id"
                            ttDataName="item_name"
                        ></tt-select>
                        <tt-select
                            class="col-xs-12 sp-0"
                            ttLabel="printer"
                            [ttModel]="page.printer_id"
                            (ttModelChange)="onPrinterChanged($event)"
                            [ttData]="selectListPrinters"
                            ttDataId="item_id"
                            ttDataName="item_name"
                        ></tt-select>
                        <tt-select
                            class="col-xs-12 sp-0"
                            ttLabel="report_name"
                            [ttModel]="page.report_id"
                            (ttModelChange)="onReportChanged($event)"
                            [ttData]="selectListReports"
                            ttDataId="item_id"
                            ttDataName="item_name"
                        ></tt-select>
                    </ng-container>
                </tt-card>
                <tt-button-save class="col-xs-12 sp-0" ttText="case_save" [ttLocked]="lockedSave" (ttClick)="saveChanges()" ttTextAlign="center"></tt-button-save>
            </div>
            <div class="col-xs-12 sp-0">
                <tt-grid *ngIf="!!grid" [(ttOptions)]="grid"></tt-grid>
            </div>
        </form>
    </div>
</tt-page>
